import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import { Actionable } from '../bos/actionable.js'
import { jsonProperty, jsonClass } from '@sumbricht/json-class-serializer'
import { BoVisitor } from '../bos/bo-visitor.js'

@jsonClass('LowgileAction')
export class LowgileAction extends Actionable {
	@jsonProperty(Boolean)
	isRunAsEffect?: boolean

	constructor(init?: Partial<LowgileAction>) {
		super()
		assignCommonProperties(this, init)
	}

	visit(visitor: BoVisitor, pathPrefix: (string | number)[]): void {
		super.visit(visitor, pathPrefix)
	}

	getMethodName() {
		return `action_${this.name}`
	}
}
